import { useDispatch } from "react-redux";
import { openAlert } from "..";
import { ConfirmationAlertState } from "../types";

export const useConfirmationAlert = () => {
  const dispatch = useDispatch();

  const handleAlert = (payload: ConfirmationAlertState) => {
    setTimeout(() => {
      dispatch(openAlert(payload));
    }, 0);
  };

  return { handleAlert };
};
